import { gql } from '@apollo/client';

export const CALCULATE_INSURANCE_OFFERS = gql`
  mutation CalculateInusranceOffers($input: Input) {
    offersResponce(input: $input)
      @rest(
        endpoint: "api"
        type: "GetInsuranseOffers"
        path: "calculate"
        method: "POST"
      ) {
      companies
    }
  }
`;
